<ndt-add-phone-number-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (saveAndAddAnother)="onCreateAndAddAnother()"
>
</ndt-add-phone-number-view>
